import { ILicense } from '../../@types';
import * as constants from './constants';
import { LicenseAction } from './action';

export interface ILicenseState {
  license: ILicense;
}

export const initialState: ILicenseState = {
  license: {
    id: undefined,
    licenseKey: '',
    bundleId: '',
    costInitial: 0,
    costRenewal: 0,
    customerId: undefined,
    expirationDate: new Date(),
    expireAction: 'WARN',
    numUniqueUsers: 0,
    terms: '',
    appName: '',
    os: 'iOS',
    createdDate: new Date(),
    updatedDate: new Date(),
    status: 'PENDING'
  }
};

export const reducer = (
  state: ILicenseState = initialState,
  action: LicenseAction
): ILicenseState => {
  switch (action.type) {
    case constants.UPDATE_LICENSE:
      return {
        ...state,
        license: {
          ...action.payload,
          expirationDate: new Date(action.payload.expirationDate),
          createdDate: new Date(action.payload.createdDate),
          updatedDate: new Date(action.payload.updatedDate)
        }
      };
    case constants.CLEAR_LICENSE:
      return {
        ...state,
        license: initialState.license
      };
    /* istanbul ignore next */
    default:
      return {
        ...state
      };
  }
};



// WEBPACK FOOTER //
// ./src/modules/license/reducer.ts